import React from 'react';
import PropTypes from 'prop-types';

const Button = ({btnClassName, text, icon, ...props  }) => {
  const className = `btn ${btnClassName}`;

  return (
      <button className={className} {...props}>
        {icon && <i className={`${icon} inner-icon`}></i>}
        {text}
      </button>
  );
};

Button.propTypes = {
  text: PropTypes.string,
  btnClassName: PropTypes.string,
  type: PropTypes.string,
  disabled: PropTypes.bool,
};

Button.defaultProps = {
  text: 'Submit',
  btnClassName: '',
  type: '',
  disabled: false,
};

export default Button;

